import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "pill"]

  choose(event) {
    const category = event.params.category

    this.pillTargets.forEach((pill) => {
      pill.classList.toggle("ms-pill--active", pill === event.currentTarget)
    })

    this.cardTargets.forEach((card) => {
      const matches = category === "all" || card.dataset.flockCategory === category
      card.hidden = !matches
    })
  }
}
